/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ formats: NonNullable<unknown> }} Subtitle_Import_Supported_Formats_LabelInputs */



/**
* | output |
* | --- |
* | "Supported formats: {formats}" |
*
* @param {Subtitle_Import_Supported_Formats_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_supported_formats_label = /** @type {((inputs: Subtitle_Import_Supported_Formats_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Supported_Formats_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Formats pris en charge : ${i?.formats}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Unterstützte Formate: ${i?.formats}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Formati supportati: ${i?.formats}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Поддерживаемые форматы: ${i?.formats}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Formatos admitidos: ${i?.formats}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`支持的格式：${i?.formats}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`サポートされている形式: ${i?.formats}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समर्थित प्रारूप: ${i?.formats}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Formatos suportados: ${i?.formats}`)
	return /** @type {LocalizedString} */ (`Supported formats: ${i?.formats}`)
});